export const PARAMETER_STATUS = 'status';
export const PARAMETER_ITEMID = 'itemId';
export const PARAMETER_ITEMSKU = 'itemSku';
export const PARAMETER_DISPLAYITEMSKU = 'displayItemSku';
export const PARAMETER_ZIP = 'zip';
export const PARAMETER_VENDORID = 'vendorId';
export const PARAMETER_RETURNURL = 'returnUrl';
export const PARAMETER_REFID = 'refId';
export const PARAMETER_OLDCONFIGID = 'old_configid';
export const PARAMETER_OLDCONFIGID_KEY = 'oldconfigid';
export const PARAMETER_ACCTID = 'acctid';
export const PARAMETER_SESSIONID = 'sessionId';
export const PARAMETER_COUPON = 'coupon';
export const PARAMETER_ISAS400REORDER = 'isAs400Reorder';
export const PARAMETER_SCID = 'scid';
export const PARAMETER_INTCMP = 'intcmp';
export const PARAMETER_EDITITEM = 'editItem';
export const PARAMETER_REP = 'rep';
export const PARAMETER_PRICESVCURL = 'priceSvcUrl';
export const PARAMETER_TOKEN = 'token';
export const PARAMETER_IMPRINTAREACODE = 'imprintAreaCode';
export const PARAMETER_IMPRINTLOCATION = 'imprintLocation';
export const PARAMETER_SAMPLE = 'sample';
export const PARAMETER_CONTACTNUMBER = 'contactnumber';
export const PARAMETER_ORDERID = 'orderid';
export const PARAMETER_ORDERSEQUENCE = 'ordersequence';
export const PARAMETER_TEMPLATEID = 'templateId';
export const PARAMETER_EXACTREORDER = 'exactReorder';
export const PARAMETER_COMPANYNAME = 'companyName';
export const PARAMETER_REQUIREDUPSELLITEMID = 'requiredUpsellItemId';
export const PARAMETER_REQUIREDUPSELLSONLY = 'requiredUpsellsOnly';
export const PARAMETER_SHOPPINGCARTID = 'shoppingCartId';
export const PARAMETER_MAINITEMQUANTITY = 'mainItemQuantity';
export const PARAMETER_PACKAGESIGNATURE = 'packageSignature';
export const PARAMETER_QUANTITYINCART = 'quantityInCart';
export const PARAMETER_STARTINGTOTALPRICE = 'startingTotalPrice';
export const PARAMETER_HASNOIMPRINTOPTIONS = 'hasNoImprintOptions';
export const PARAMETER_BOMOPTIONSVALIDATIONOFF = 'bomOptionsValidationOff';
export const ACTION_EDIT = 'edit';
export const ACTION_NEW = 'new';
export const ACTION_REORDEREDIT = 'reorderedit';
export const ACTION_DESIGNLATER = 'designlater';
export const ACTION_EDITTEMPLATE = 'edittemplate';
export const ACTION_EDITCARTUPSELLS = 'editcartupsells';
export const ACTION_SHIPPING = 'shipping';
export const ACTION_VIRTUALPROOF = 'virtualproof';
export const TRUE = 'true';
export const NAVINK_RETURNURL = 'UP';
export const NODE_ENV_DEVP = 'development';

export const parameterName = [
  PARAMETER_STATUS,
  PARAMETER_ITEMID,
  PARAMETER_ITEMSKU,
  PARAMETER_DISPLAYITEMSKU,
  PARAMETER_ZIP,
  PARAMETER_VENDORID,
  PARAMETER_RETURNURL,
  PARAMETER_REFID,
  PARAMETER_OLDCONFIGID,
  PARAMETER_OLDCONFIGID_KEY,
  PARAMETER_ACCTID,
  PARAMETER_SESSIONID,
  PARAMETER_COUPON,
  PARAMETER_ISAS400REORDER,
  PARAMETER_SCID,
  PARAMETER_INTCMP,
  PARAMETER_EDITITEM,
  PARAMETER_REP,
  PARAMETER_PRICESVCURL,
  PARAMETER_TOKEN,
  PARAMETER_IMPRINTAREACODE,
  PARAMETER_IMPRINTLOCATION,
  PARAMETER_SAMPLE,
  PARAMETER_CONTACTNUMBER,
  PARAMETER_TEMPLATEID,
  PARAMETER_ORDERID,
  PARAMETER_ORDERSEQUENCE,
  PARAMETER_EXACTREORDER,
  PARAMETER_COMPANYNAME,
  PARAMETER_REQUIREDUPSELLITEMID,
  PARAMETER_REQUIREDUPSELLSONLY,
  PARAMETER_SHOPPINGCARTID,
  PARAMETER_MAINITEMQUANTITY,
  PARAMETER_QUANTITYINCART,
  PARAMETER_STARTINGTOTALPRICE,
  PARAMETER_HASNOIMPRINTOPTIONS,
  PARAMETER_BOMOPTIONSVALIDATIONOFF,
];

export const configuratorStep = {
  unsupportBrowserError: -10,
  loading: -1,
  bom: 0,
  imprintarea: 1,
  imprintoption: 2,
  canvas: 3,
  upsell: 11,
  upsellCustomization: 12,
  template: 21,
  mobileSaveProject: 30,
  mobileEmail: 31,
  warning: 40,
  lowDpi: 41,
  error: 99,
  shipping: 50,
  lite: 60,
};

export const configuratorAction = {
  new: 0,
  edit: 1,
  reorderEdit: 2,
  designLater: 3,
  editTemplate: 5,
  editCartUpsells: 8,
  shipping: 6,
  virtualProof: 7,
};

export const messageBoxButtons = {
  ok: 0,
  okCancel: 1,
};
export const messageBoxButtonsCaptionDefault = {
  ok: 'OK',
  cancel: 'Cancel',
};

export const reorderResultType = {
  failed: 0,
  edit: 1,
  exact: 2,
};

export const studioItemType = {
  nonDigital: 0,
  digital: 1,
  screenPrintedDigital: 2,
};

export const internalBrands = ['100010', '100020', '100030', '100050', '100060', '100070', '100080', '31', '106'];
export const imprintOptionStep = {
  NA: -1,
  Layout: 0,
  TextColor: 1,
};

export const nextgenUiSteps = {
  ProductDetails: 0,
  Customize: 1,
  VirtualProof: 2,
  GoCart: -1,
};

export const nextgenUiStepButtons = {
  Next: 0,
  AddToCart: 1,
  VirtualProof: 2,
};

export const nextgenProductDetailModels = {
  OnPage: 0,
  Modal: 1,
};

export const errorInfoExclude = ['Request failed with status code 500'];

export const internalServerExceptionCode = {
  cartItemNotExist: 4002,
};

export const internalServerExceptionMessage = {
  [internalServerExceptionCode.cartItemNotExist]: 'The item is no longer in your cart. Please add the item again.',
};

export const validateResultMessage = {
  missingArt:
    'We apologize, but your previous imprint text and/or art/logo cannot be generated at this time. Please enter your imprint in the studio.',
  bomOptionChanged: 'The product options have changed since your last order. Please make a selection and continue.',
  bomOptionSoldOut:
    'Some products have sold out. Please press the "Return to Product Options" button or the "Edit" button to return to the previous step and make a selection again and continue.',
  imprintOptionChanged: 'The imprint options have changed since your last order. Please make a selection and continue.',
  lessThanMinQuantity: 'Please select the quantity to continue.',
};

export const promoStudioUITypeValue = {
  NoUI: 0,
  LiteUI: 1,
  FullUI: 2,
};

export const deviceValue = {
  Mobile: 0,
  Desktop: 1,
};

export const PackageSignatureBomOptions = 'bom-options';
